var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { ELSCommonUIConstants } from '@els/els-ui-common-react';
import { errorService } from 'services';
import { ELSIcon } from 'components/common';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLoadingChunkFailed = function () {
            var chunkFailedMessage = /Loading chunk [\d]+ failed/;
            var error = _this.state.error;
            if ((error === null || error === void 0 ? void 0 : error.message) && chunkFailedMessage.test(error.message)) {
                window.location.reload();
            }
        };
        _this.state = { error: null };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            error: error
        });
        errorService.ErrorService.log({ err: error, previousState: errorInfo, previousStateParams: null });
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.error) {
            if (this.state.error.name === 'InvalidTokenError') {
                return <Redirect to={"/".concat(ELSCommonUIConstants.security.States.NotAuthorized)}/>;
            }
            this.handleLoadingChunkFailed();
            return (<div className="u-els-padding-3x u-els-text-center">
          <div>
            <ELSIcon name="alert-unexpected-error" size="4x"/>
          </div>
          <h2>Oops, something went wrong.</h2>
          <div>
            <a href="/">Go Home</a>
          </div>
        </div>);
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(Component));
export default ErrorBoundary;
